import { render, staticRenderFns } from "./addPayType.vue?vue&type=template&id=136a8414"
import script from "./addPayType.vue?vue&type=script&lang=js"
export * from "./addPayType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports